<div class="feature">
  <div class="marquee">
    <div class="track">
      <div class="content">
        <img loading="lazy" src="{{ item.img }}" *ngFor="let item of items" alt="featured-img" />
      </div>
    </div>
    <div class="track">
      <div class="content">
        <img loading="lazy" src="{{ item.img }}" *ngFor="let item of items" alt="featured-img" />
      </div>
    </div>
  </div>
</div>
